export default {
	BASE_STORAGE: process.env.REACT_APP_BASE_STORAGE,
	BASE_API: process.env.REACT_APP_BASE_API,
	BASE_PUBLIC: process.env.REACT_APP_BASE_PUBLIC,
	TIMEZONE: 'America/Caracas',
	LEVELS: {
		ADMIN: 1,
		DOCTOR: 2,
		PATIENT: 3,
		COMPANY: 4,
	},
	USER: {
		VERIFIED: {
			PENDING: 0,
			IN_PROCESS: 1,
			VERIFIED: 2,
			REJECTED: 3
		},
		STATUS: {
			ACTIVE: 1,
			INACTIVE: 0
		}
	},
	MODULES: {
		USERS: 1
	},
	DOCUMENT_TYPES: {
		V: 1,
		E: 2,
		G: 3,
		J: 4,
		PASSPORT: 5
	},
	VERIFIED_STATUS: {
		PENDING: 0,
		VERIFIED: 1,
		REJECTED: 2
	},
	STATUS_PAYMENT: {
		PENDING: 1,
		IN_PROGRESS: 2,
		FINISH: 3,
		CANCELLED: 4
	},
	STATUS_PAYMENT_MADE: {
		PENDING: 0,
		PAID: 1,
	},
	APPOINTMENT: {
		TYPE: {
			IN_PERSON: 1,
			ONLINE: 2,
		},
		DURATION: {
			IN_PERSON: 20,
			ONLINE: 20,
		},
		STATUS: {
			PENDING: 0,
			IN_PROCESS: 1,
			RESCHEDULED: 2,
			FINISHED: 3,
			CANCELLED: 4,
		},
		RESCHEDULE_STATUS: {
			PENDING: 0,
			ACCEPTED: 1,
			REJECTED: 2,
		},
	},
	PLAN: {
		STATUS: {
			ACTIVE: 1,
			INACTIVE: 0,
		}
	}
}